import moment from 'moment';
import _ from 'lodash';

export class RequestDataParser {
   static getFormattedDOB = (admitObj) => {
    return moment(admitObj.dob).format("YYYY-MM-DD");
  };

   static getAddressLines = (admitObj, isTemporaryAddress) => {
    let arr = ["", "", "", ""];

    if (isTemporaryAddress) {
      if (!admitObj?.streetTemporary && !admitObj?.cityTemporary && !admitObj?.postTownTemporary && !admitObj?.countyTemporary) {
        return null
      }

      arr[0] = admitObj?.streetTemporary;
      arr[1] = admitObj?.postTownTemporary;
      arr[2] = admitObj?.cityTemporary;
      arr[3] = admitObj?.countyTemporary;

      return arr;
    }

    if (!admitObj.street && !admitObj.city && !admitObj.postTown && !admitObj.county) {
      return null
    }

    if (admitObj.street) {
      arr[0] = admitObj.street
    }
    if (admitObj.city) {
      arr[2] = admitObj.city
    }
    if (admitObj.postTown) {
      arr[1] = admitObj.postTown
    }
    if (admitObj.county) {
      arr[3] = admitObj.county
    }

    return arr;
  };

   static getPhoneNumbers = (admitObj, isExt = false) => {
    let temp = [];

    if (!admitObj.phoneNumbers || _.isEmpty(admitObj.phoneNumbers) ) {
      return null;
    }

    admitObj.phoneNumbers.forEach((phone) => {
      if (isExt) {
        temp.push({
          number: phone.number,
          phone: phone.number,
          numberType: phone.type,
          type: phone.type,
        });
      } else {
        temp.push({
          number: phone.number,
          numberType: phone.type,
        });
      }
    });

    return temp;
  };

   static getEmails = (admitObj) => {
    let temp = [];

    if (!admitObj.emailAdresses || _.isEmpty(admitObj.emailAdresses) ) {
      return null;
    }

    admitObj.emailAdresses.forEach((email) => {
        temp.push({ emailAddress: email.emailAddress })
    }
    );
    return temp;
  };

   static mapEhicObject = (admitObj) => {
     let ehicObject;
     if (!admitObj?.patientNumbers) return null;
     ehicObject = admitObj?.patientNumbers.find((patientNumber) => patientNumber.type === "EhicNumber" || patientNumber.simpleType === 'EhicNumber');

     return ehicObject;
   }

  static mapHouseholdObject = (admitObj) => {
    let temp = [];
    if (!admitObj.household || _.isEmpty(admitObj.household)) {
      return null;
    } else {
      admitObj.household.forEach((household) => {
        let obj = {};
        obj = {
          ...obj,
          householdInformation: household.householdInformation,
          householdPeoples: [],
        };
        const householdPeoples = household.householdPeople;
        if (householdPeoples && householdPeoples.length > 0) {
          householdPeoples.forEach((people) => {
            const peopleObj = {
              parentalResponsibility: people.parentalResponsibility,
              name: people.name,
              age: people.age,
              relationship: people.relationship,
              contact: people.contact,
            };

            obj = {
              ...obj,
              householdPeoples: [...obj["householdPeoples"], peopleObj],
            };
          });
        }

        temp = [...temp, obj];
      });
    }
    return temp;
  };

   static mapEscortObject = (admitObj) => {
    let temp = [];
    if (!admitObj.escortArray || _.isEmpty(admitObj.escortArray)) {
      return null;
    } else {
      admitObj.escortArray.forEach((escort) => {
        const obj = {
          parentalResponsibility: escort.parentalResponsibility,
          attendedWithChild: escort.attendedWithChild,
          name: escort.name,
          age: escort.age,
          relationship: escort.relationship,
          contact: escort.contact,
        };

        temp = [...temp, obj];
      });
    }
    return temp;
  };

   static mapNextOfKinObject = (admitObj, isExt = false) => {
    let temp = [];

    if (!admitObj.nokList || admitObj.nokList.length === 0) {
      return null;
    }

    admitObj.nokList.forEach((nextOfKin) => {
      let obj = {
        firstName: nextOfKin.firstName,
        familyName: nextOfKin.lastName,
        relationship: {
          __id: nextOfKin.relationship.__id,
        },
        phoneNumber: nextOfKin.phoneNumber,
      };

      if (isExt) {
        obj.relationship.code = nextOfKin.relationship.__code;
      }

      if (RequestDataParser.getAddressLines(nextOfKin)) {
        obj = {
          ...obj,
          address: {
            addressLines: RequestDataParser.getAddressLines(nextOfKin),
            postalCode: nextOfKin.postalCode,
          }
        }
      }

      temp = [...temp, obj];
    });

    return temp;
  };
   static mapSchoolObject = (admitObj) => {
     let objToReturn;

     if (!admitObj.schoolName && !admitObj.schoolContact && !admitObj.schoolAddress && !admitObj.schoolPostalCode) {
       return null;
     }

     objToReturn = {
       name: admitObj.schoolName,
       contact: admitObj.schoolContact,
       address: {
         addressLines: [admitObj.schoolAddress],
         postalCode: admitObj.schoolPostalCode,
       }
     }

     return objToReturn;
   }

   static getGpId = admitObj => {
     if (!admitObj.gp) {
       return null;
     }

     const gpId = admitObj.gp?.gpCode || admitObj.gp?.__id || admitObj.gp?.__href.split("/").pop();
     return ({
       "__id": gpId
     })
   }

   static getSurgeryId = admitObj => {
     if (!admitObj.surgery) {
       return null;
     }

     const surgeryId = admitObj?.surgery?.__id;
     return ({
          "__id": surgeryId
         })
   }
}

export class SelectPatientParser {
  static getAddresses = (field, tempAddress) => {
    let street = tempAddress ? null : "";
    let city =  tempAddress ? null : "";
    let postTown =  tempAddress ? null : "";
    let county =  tempAddress ? null : "";

    if (!field) {
      return [
        street,
        city,
        postTown,
        county,
      ];
    }

    switch (field.length) {
      case 1:
        street = field[0];
        break;
      case 2:
        street = field[0];
        city = field[1];
        break;
      case 3:
        street = field[0];
        city = field[1];
        county = field[2];
        break;
      case 4:
        street = field[0];
        city = field[2];
        postTown = field[1];
        county = field[3];
        break;
      default:
        break;
    }

    return [
      street,
      city,
      postTown,
      county,
    ];
  };

  static getGPId = (patient) => {
    if (!patient.gp) return;
    return patient.gp;
  };

  static getSurgeryId = (patient) => {
    if (!patient.surgery) return;
    return patient.surgery;
  };

  static getHistoryOfPresentingComplaint = (patient) => {
    let presentingComplaint = '';
    if (patient?.clerking?.historicPresentingComplaint) presentingComplaint = patient?.clerking?.historicPresentingComplaint;
    else if (patient?.studies?.seeAndTreat?.historyOfPresentingComplaint) presentingComplaint = patient?.studies?.seeAndTreat?.historyOfPresentingComplaint;
    else if (patient?.triage?.historicPresentingComplaint) presentingComplaint = patient?.triage?.historicPresentingComplaint;
    else if (patient?.metadata?.historyOfPresentingComplaint) presentingComplaint = patient?.metadata?.historyOfPresentingComplaint;
    return presentingComplaint;
  };

  static getHospitalNumber = patient => {
    let validHospitalNumber = patient.hospitalNumber;
    if (!validHospitalNumber) {
      validHospitalNumber = patient.__id;
    }
    if (!validHospitalNumber) {
      validHospitalNumber = patient.__href.split("/").pop();
    }

    return validHospitalNumber;
  }

  static getNHSNumber = (patient) => {
      const number = patient?.patientNumbers
          ? patient?.patientNumbers.find(
              (number) => number.type === "NhsNumber" || number.type === 'NHS' || number.simpleType === "NhsNumber"
          )?.number
          : "";

      return number;
  };

  static getEhicNumber = (patient) => {
    const ehicNumber = patient?.patientNumbers.find(
      (number) => number.simpleType === "EhicNumber" || number.type === "EhicNumber"
    )?.number;

    return ehicNumber || "";
  }

  static getEmail = (patient) => {
    let emailList = [];
    if (_.isEmpty(patient.emails)) {
      return null;
    }

    patient?.emails.forEach((email) => {
      emailList.push({
        emailAddress: email.emailAddress,
        type: email?.emailType,
      })
    });

    return emailList;
  };

  static getPhoneNumbers = (patient) => {
    if (_.isEmpty(patient?.phoneNumbers)) {
      return null;
    }
    return patient?.phoneNumbers.map((phone) => {
      return {
        number: phone.number,
        type: phone?.numberType,
      };
    });
  };

  static getNextOfKins = (patient) => {
    let nokList = [];
    if (_.isEmpty(patient?.nextOfKins)) {
      return null;
    }
    patient?.nextOfKins.forEach((nok) => {
      let nokObj = {
        firstName: nok.firstName || "",
        lastName: nok.familyName || "",
        relationship: nok.relationship || null,
        phoneNumber: nok.phoneNumber || "",
        postalCode: "",
        street: "",
        city: "",
        postTown: "",
        county: "",
      };

      if (nok.address) {
        const [ street, city, postTown, county ] = SelectPatientParser.getAddresses(
            nok.address.addressLines
        );
        nokObj = {
          ...nokObj,
          postalCode: nok.address.postalCode || "",
          street,
          city,
          postTown,
          county,
        };
      }

      nokList.push(nokObj);
    });
    return nokList;
  };
}
